import React from "react";
import Image from "react-image-webp";
import "../css/Header.css";

import BulletPointBlink from "./buttons/BulletPointBlink";

import backgroundLeft from "../images/header_background_left.png";
import backgroundLeftWebp from "../images/header_background_left.webp";

import backgroundRight from "../images/header_background_right.png";
import backgroundRightWebp from "../images/header_background_right.webp";

import line from "../images/underline.png";

const Header = () => {
    return (
        <div className="Header" id="home">
            <Image
                webp={backgroundLeftWebp}
                src={backgroundLeft}
                alt="Background Left"
                className="header-background-left"
            />
            <Image
                webp={backgroundRightWebp}
                src={backgroundRight}
                alt="Background Right"
                className="header-background-right"
            />
            <div className="header-filter"></div>
            <p>15 DÍAS DE ENTRENAMIENTO INTENSIVO</p>
            <h2>CURSO DESCARGABLE</h2>
            <h1>
                <span>
                    APRENDE BLENDER
                    <img
                        src={line}
                        alt="underline"
                        className="header-underline"
                    />
                </span>
                <br />
                EN 15 DÍAS
            </h1>
            <h3>
                Es tu gran oportunidad para crear un personaje en BLENDER
                <br/>
                “No necesitas conocimientos previos”
            </h3>
            <div className="start-course">
                <BulletPointBlink color={"#77bf41"} />
                <h4>Inicia Ahora</h4>
                <BulletPointBlink color={"#77bf41"} />
            </div>
        </div>
    );
};

export default Header;
